export default customElements.define('w-fancy-radio-list', class FancyRadioList extends wealthify.CustomElementBaseClass {  
    constructor () {
        const config = {
            styleSelector: 'c-fancy-radio-list',
            templateHTML: `
                <div class="c-fancy-radio-list" data-root>
                    <fieldset class="c-fancy-radio-list__form">
                        <div class="c-fancy-radio-list__header">
                            <legend class="c-fancy-radio-list__title" hidden data-legend></legend>
                            <w-chip class="c-fancy-radio-list__more-button-desktop u-display__none" hidemobile="true" hidetablet="true" context="button" type="secondary" iconleft="info-circle" data-morebutton></w-chip>
                        </div>
                        <div data-child-root></div>
                        <div class="u-display__hidden" data-formcontainer></div>
                    </fieldset>
                    <div class="c-fancy-radio-list__button-group u-display__none--mobile u-display__none--tablet" data-button-list-desktop></div>
                    <div class="c-fancy-radio-list__button-group u-display__none--desktop" data-button-list-mobile></div>
                    <div class="u-display__none--mobile u-display__none--tablet" data-description-list-desktop></div>
                    <div class="u-display__none--desktop" data-description-list-mobile></div>
                    <w-chip class="c-fancy-radio-list__more-button-mobile u-display__none" hidedesktop="true" context="button" type="secondary" iconleft="info-circle" data-morebutton></w-chip>
                </div>`,
            hasChildren: true,
            cacheDom: [ 'data-legend', 'data-formcontainer', 'data-morebutton', 'data-button-list-desktop', 'data-button-list-mobile', 'data-description-list-desktop', 'data-description-list-mobile' ]
        };  

        super(config);

        this.onConnectedCallback = () => {
            this.value = this.value || null;
        };
    }

    static get requiredItemsProperties () {
        return [
            'label',
            'value'
        ];
    }

    static get observedProps () {
        return [
            new wealthify.Prop('buttondata', {type: wealthify.propTypes.Object()}),
            new wealthify.Prop('headinglarge', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('items', {
                type: wealthify.propTypes.Array(),
                validators: [wealthify.propValidators.ArrayObjectContainsKeys(this.requiredItemsProperties)]
            }),
            new wealthify.Prop('key', {required: true}),
            new wealthify.Prop('mobileview', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('shape'),
            new wealthify.Prop('shapemobile'),
            new wealthify.Prop('selected', {
                type: wealthify.propTypes.Number(),
                validators: [wealthify.propValidators.IsPositiveNumber()]
            }),
            new wealthify.Prop('titleprop'),
            new wealthify.Prop('treatasbuttons', {
                default: false,
                type: wealthify.propTypes.Boolean()
            }),
            new wealthify.Prop('disabled-items', {
                default: [],
                type: wealthify.propTypes.Array()
            }),
            wealthify.props.DarkMode()
        ];
    }

    get propCallbacks () {
        return {
            buttondata: (value) => {
                if (Object.keys(value).length === 0) {
                    return;
                }

                this.dom.morebutton.forEach((button) => {
                    button.classList.remove('u-display__none');
                });

                for (let key in value) {
                    this.dom.morebutton.forEach((button) => {
                        button[key] = value[key];
                    });
                }
            },
            headinglarge: () => {
                const classListAction = this.headinglarge ? 'add' : 'remove';

                this.dom.legend.classList[classListAction](`${this.styleSelector}__title--large`);
            },
            items: (value) => {
                const itemsAmount = value.length;

                this.dom.radiogroups = [];

                value.forEach((item, index) => {
                    this.dom.radiogroups[index] = {description: null};

                    const input = this.dom.radiogroups[index].input = document.createElement('input');
                  
                    const [desktopLabel, desktopFancyButton] = this._createDesktopItems(index, itemsAmount);
                    const [mobileLabel, mobileFancyButton] = this._createMobileItems(index, itemsAmount);

                    const isDisabled = this.dom.radiogroups[index].isDisabled = this.disabledItems.includes(item.value);
                    
                    mobileFancyButton.label = item.labelmobile || item.label;
                    mobileFancyButton.shape = this.shapemobile || this.shape;
                    
                    desktopFancyButton.label = item.label;
                    
                    input.setAttribute('type', 'radio');
                    input.setAttribute('value', item.value);
                    
                    if(isDisabled) {
                        input.setAttribute('aria-disabled', true);

                        mobileFancyButton.ariadisabled = true;
                        desktopFancyButton.ariadisabled = true;
                    }

                    if (this.selected === index && !isDisabled) {
                        input.checked = true;
                    }

                    if (item.description) {
                        const descriptionMobile = this.dom.radiogroups[index].descriptionMobile = this._createDescription(index, item.description);
                        const descriptionDesktop = this.dom.radiogroups[index].descriptionDesktop = this._createDescription(index, item.description);

                        this.dom.descriptionListMobile.appendChild(descriptionMobile);
                        this.dom.descriptionListDesktop.appendChild(descriptionDesktop);
                    }

                    if (item.descriptionMobile) {
                        // Override mobile description if specified
                        this.dom.radiogroups[index].descriptionMobile.innerHTML = item.descriptionMobile;
                    }

                    if (item.onclickprop && !isDisabled) {
                        desktopFancyButton.onclickprop = item.onclickprop;
                        mobileFancyButton.onclickprop = item.onclickprop;
                    }

                    this._addInputAttributes(index);

                    this.dom.formcontainer.appendChild(input);
                    this.dom.buttonListDesktop.appendChild(desktopLabel);
                    this.dom.buttonListMobile.appendChild(mobileLabel);

                    this._addEvent(this.dom.radiogroups[index], index);
                });
            },
            key: () => {
                if (!this.dom.radiogroups) {
                    return;
                }
        
                Array.prototype.forEach.call(this.dom.radiogroups, (group, index) => {
                    this._addInputAttributes(index);
                });
            },
            mobileview: () => {
                if (this.mobileview) {
                    this.dom.buttonListDesktop.classList.add('u-display__none');
                    this.dom.buttonListDesktop.classList.remove('u-display__none--mobile');
                    this.dom.buttonListDesktop.classList.remove('u-display__none--tablet');
                    this.dom.buttonListMobile.classList.remove('u-display__none--desktop');
                } else {
                    this.dom.buttonListDesktop.classList.remove('u-display__none');
                    this.dom.buttonListDesktop.classList.add('u-display__none--mobile');
                    this.dom.buttonListDesktop.classList.add('u-display__none--tablet');
                    this.dom.buttonListMobile.classList.add('u-display__none--desktop"');
                }
            },
            shape: (value) => {
                if (!this.dom.radiogroups) {
                    return;
                }
        
                Array.prototype.forEach.call(this.dom.radiogroups, (group) => {
                    group.desktopFancyButton.shape = value;
                });
            },
            shapemobile: (value) => {
                if (!this.dom.radiogroups) {
                    return;
                }
        
                Array.prototype.forEach.call(this.dom.radiogroups, (group) => {
                    group.mobileFancyButton.shape = value;
                });
            },
            selected: (value) => {
                if (!this.dom.radiogroups) {
                    return;
                }

                if (value > this.items.length - 1) {
                    wealthify.error.throwError(this.tagName, 'Value passed to selected is not present in radio list.');
                }

                this._selectOption(value);
            },
            titleprop: (value) => {
                this.dom.legend.innerHTML = value;

                if (value !== '') {
                    this.dom.legend.removeAttribute('hidden');
                } else {
                    this.dom.legend.setAttribute('hidden', true);
                }
            },
            treatasbuttons: () => {},
            disabledItems: (value) => this.items?.filter(item => value.includes(item.value)).map(item => item.value)
        };
    }

    _createDescription (index, descriptionText) {
        const description = document.createElement('w-speech-box');

        description.innerHTML = descriptionText;
        description.tailoffset = this._getOffset(this.items.length, index);
        description.classList.add('u-display__hidden');

        return description;
    }

    get valid () {
        return this.dom.radiogroups[0].input.checkValidity();
    }

    _createDesktopItems (index, numberOfItems) {
        const desktopLabel = this.dom.radiogroups[index].desktopLabel = document.createElement('label');
        const desktopFancyButton = this.dom.radiogroups[index].desktopFancyButton = document.createElement('w-fancy-button');

        desktopLabel.classList.add(`${this.styleSelector}__item`);

        desktopFancyButton.ariahidden = true;
        desktopFancyButton.shape = this.shape;
        desktopFancyButton.first = index === 0;
        desktopFancyButton.last = index === numberOfItems - 1;

        desktopLabel.appendChild(desktopFancyButton);

        return [desktopLabel, desktopFancyButton];
    }

    _createMobileItems (index, numberOfItems) {
        const mobileLabel = this.dom.radiogroups[index].mobileLabel = this.dom.radiogroups[index].desktopLabel.cloneNode(true);
        const mobileFancyButton = this.dom.radiogroups[index].mobileFancyButton = mobileLabel.querySelector('w-fancy-button');

        mobileFancyButton.first = index === 0;
        mobileFancyButton.last = index === numberOfItems - 1;

        return [mobileLabel, mobileFancyButton];
    }

    _addInputAttributes (index) {
        if (this.key === undefined) {
            return;
        }

        const inputId = `${this.key}-${index + 1}`;

        this.dom.radiogroups[index].input.name = this.key;
        this.dom.radiogroups[index].input.id = inputId;
        this.dom.radiogroups[index].desktopLabel.setAttribute('for', inputId);
        this.dom.radiogroups[index].mobileLabel.setAttribute('for', inputId);

        if (this.dom.radiogroups[index].descriptionDesktop) {
            // Only associate desktop description with input
            const descriptionId = `description-${inputId}`;

            this.dom.radiogroups[index].descriptionDesktop.id = descriptionId;
            this.dom.radiogroups[index].input.setAttribute('aria-describedby', descriptionId);
        }
    }
    
    _selectOption(index){
        this._resetButtonStates();

        const group = this.dom.radiogroups[index];

        if (group.descriptionDesktop) {
            group.descriptionDesktop.classList.remove('u-display__hidden');
        }

        if (group.descriptionMobile) {
            group.descriptionMobile.classList.remove('u-display__hidden');
        }
        
        this.value = group.input.value; 
        
        group.mobileFancyButton.state = 'selected';
        group.desktopFancyButton.state = 'selected';
        
        this.dispatchEvent(new Event('valuechange', {
            'bubbles': true, 
            'cancelable': true,
        }));
    }
    
    _resetButtonStates() {
        Array.prototype.forEach.call(this.dom.radiogroups, group => {
            group.mobileFancyButton.state = 'unselected';
            group.desktopFancyButton.state = 'unselected';

            if (group.descriptionDesktop) {
                group.descriptionDesktop.classList.add('u-display__hidden');
            }

            if (group.descriptionMobile) {
                group.descriptionMobile.classList.add('u-display__hidden');
            }
        });
    }

    _changeFocus (group, addFocus) {
        const classListAction = addFocus ? 'add' : 'remove';

        group.mobileLabel.classList[classListAction](`${this.styleSelector}__item--focused`);
        group.desktopLabel.classList[classListAction](`${this.styleSelector}__item--focused`);
    }

    _recreateKeyboardButtonClick (event, group) {
        if (event.key === 'Enter') {
            group.desktopFancyButton.click();
            event.preventDefault();
        }
    }

    _addEvent (group, index) {
        if (this.treatasbuttons) {
            if(!group.isDisabled) {
                group.input.addEventListener('keydown', (event) => this._recreateKeyboardButtonClick(event, group));
            }

            group.input.addEventListener('focus', () => this._changeFocus(group, true));
          
        } else {               
            group.input.addEventListener('click', event => {
              
                if(group.isDisabled) {
                    event.preventDefault();
                    
                    return;
                }
                  
                this._selectOption(index);

                // Set focus to currently selected radio button to
                // allow next/previous keyboard navigation
                group.input.focus();
            });
                
            group.mobileFancyButton.addEventListener('click', event => {
                // Used to disable focus state
                this.#radioNavigatedByKeyboard = false;

                group.input.click();

                event.preventDefault();
            });
              
            group.desktopFancyButton.addEventListener('click', event => {
                // Used to disable focus state
                this.#radioNavigatedByKeyboard = false;

                group.input.click();

                event.preventDefault();
            });
        }

        group.input.addEventListener('keydown', () => {
            // Used to enable focus state
            this.#radioNavigatedByKeyboard = true;
        });

        group.input.addEventListener('focus', () => this._changeFocus(group, this.#radioNavigatedByKeyboard));
        group.input.addEventListener('blur', () => this._changeFocus(group));
    }

    _getOffset (itemsAmount, index) {
        const segmentPercent = 100 / itemsAmount;
        const preOffset = index * segmentPercent;

        return preOffset + (segmentPercent / 2);
    }

    // Private
    // Defaulting to true enables initial keyboard navigation focus state 
    #radioNavigatedByKeyboard = true;
});